import React from 'react';

const TableCharacteristicsOfRelationships = ({tableData}) => {

  return (

    <div className='table_container iransans'>
      <table>
        <thead>
        <tr>
          <th>ردیف</th>
          <th>نام فیلد<span>(فارسی)</span></th>
          <th>نام فیلد<span>(انگلیسی)</span></th>
          <th>نوع / دامنه</th>
          <th>طول</th>
          <th>NULL</th>
          <th>P.K</th>
          <th>C.K</th>
          <th>F.K</th>
          <th>رابطه مرجع</th>
        </tr>
        </thead>
        <tbody>
        {tableData ? tableData.map((item, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.persianName}</td>
            <td>{item.englishName}</td>
            <td>{item.type}</td>
            <td>{item.maxLength}</td>
            <td>{item.nullable}</td>
            <td>{item.pk}</td>
            <td>{item.ck}</td>
            <td>{item.fk}</td>
            <td>{item.fkDescription}</td>
          </tr>
        )) : null}
        </tbody>
      </table>
    </div>
  );
};

export default TableCharacteristicsOfRelationships;